import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from '@angular/router';
import { PageTitleComponent } from '../../layout/page-title/page-title.component';
import { SchematicsCardComponent } from '../../layout/schematic/schematics-card/schematics-card.component';
import { SchematicsStudioComponent } from '../../layout/schematic/schematics-studio/schematics-studio.component';
import { SchematicsDetailContainerComponent } from '../../layout/schematic/schematics-detail-container/schematics-detail-container.component';
import { InfoPanelComponent } from "../../layout/info-panel/info-panel.component";
import { PowerHourComponent } from '../../layout/power/power-hour/power-hour.component';
import { PleaseWaitComponent } from "../../layout/please-wait/please-wait.component";
import { ButtonComponent } from "../../layout/button/button.component";
import { SelectComponent } from "../../layout/select/select.component";
import { ToolbarComponent } from "../../layout/toolbar/toolbar.component";
import { FormsModule } from '@angular/forms';
import { DialogComponent } from '../../layout/dialog/dialog.component';
import { PanelComponent } from '../../layout/panel/panel.component';
import { SearchInputComponent } from 'app/chips/search-input/search-input.component';
import { AmCalendarPipe } from 'app/pipes/am-calendar.pipe';
import { AmDateFormatPipe } from 'app/pipes/am-date-format.pipe';
import { AmTimeAgoPipe } from 'app/pipes/am-time-ago.pipe';
import { WeatherTempComponent } from 'app/chips/weather-temp/weather-temp.component';
import { ChipComponent } from 'app/layout/chip/chip.component';
import { ButtonNotificationsComponent } from "app/layout/button-notifications/button-notifications.component";
import { ButtonAssetsComponent } from 'app/layout/button-assets/button-assets.component';
import { DialogSelectComponent } from 'app/dialogs/dialog-select/dialog-select.component';
import { ExplorerComponent } from 'app/developer/explorer/explorer.component';
import { ExplorerAssetComponent } from 'app/developer/explorer/explorer-asset/explorer-asset.component';
import { ExplorerSiteComponent } from 'app/developer/explorer/explorer-site/explorer-site.component';
import { ExplorerChartComponent } from 'app/developer/explorer/explorer-chart/explorer-chart.component';
import { SetpointQueryOccComponent } from 'app/setpoints/setpoint-query/setpoint-query-occ/setpoint-query-occ.component';
import { SetpointQueryOccFloorsComponent } from 'app/setpoints/setpoint-query/setpoint-query-occ-floors/setpoint-query-occ-floors.component';
import { SetpointQueryOccPlanComponent } from 'app/setpoints/setpoint-query/setpoint-query-occ-plan/setpoint-query-occ-plan.component';
import { SetpointQueryOccSquaresComponent } from 'app/setpoints/setpoint-query/setpoint-query-occ-squares/setpoint-query-occ-squares.component';
import { SetpointQueryOccConfigComponent } from 'app/setpoints/setpoint-query/setpoint-query-occ-config/setpoint-query-occ-config.component';
import { SetpointQueryOccTenservComponent } from 'app/setpoints/setpoint-query/setpoint-query-occ-tenserv/setpoint-query-occ-tenserv.component';
import { SetpointQueryComponent } from 'app/setpoints/setpoint-query/setpoint-query.component';
import { SetpointQueryHeaderComponent } from 'app/setpoints/setpoint-query/setpoint-query-header/setpoint-query-header.component';
import { SetpointQueryTableComponent } from "app/setpoints/setpoint-query/setpoint-query-table/setpoint-query-table.component";
import { SetpointQueryControlComponent } from 'app/setpoints/setpoint-query/setpoint-query-control/setpoint-query-control.component';
import { SetpointListComponent } from 'app/setpoints/setpoint-list/setpoint-list.component';
import { SetpointsExplorerComponent } from "app/setpoints/setpoints-explorer/setpoints-explorer.component";
import { SetpointDatesButtonComponent } from 'app/setpoints/setpoint-dates-button/setpoint-dates-button.component';
import { CalendarComponent } from 'app/layout/calendar/calendar.component';
import { AssetViewerComponent } from 'app/assets/asset-viewer/asset-viewer.component';
import { SqPowerComponent } from 'app/setpoints/setpoint-query/plugins/sq-power/sq-power.component';
import { D3BarComponent } from 'app/charts/d3-bar/d3-bar.component';
import { D3ChartComponent } from 'app/charts/d3-chart/d3-chart.component';
import { D3OccupancyComponent } from 'app/charts/d3-occupancy/d3-occupancy.component';
import { D3SiteRagChartComponent } from 'app/charts/d3-site-rag-chart/d3-site-rag-chart.component';
import { ThemePageContainerComponent } from 'app/theme/theme-page-container/theme-page-container.component';
import { ThemePageSectionComponent } from 'app/theme/theme-page-section/theme-page-section.component';
import { ButtonDatesComponent } from 'app/layout/button-dates/button-dates.component';
import { ButtonSensorsComponent } from 'app/layout/button-sensors/button-sensors.component';
import { ButtonTriggerComponent } from 'app/layout/button-trigger/button-trigger.component';
import { MapComponent } from 'app/shared/components/map/map.component';
import { DataFormComponent } from 'app/layout/data-form/data-form.component';
import { AssetIconComponent } from 'app/chips/asset-icon/asset-icon.component';
import { AssetMonitorComponent } from 'app/assets/asset-monitor/asset-monitor.component';
import { TooltipDirective } from 'app/layout/directives/tooltip.directive';
import { AssetDashboardComponent } from 'app/charts/asset-dashboard/asset-dashboard.component';
import { ButtonAssetAdminComponent } from 'app/layout/button-asset-admin/button-asset-admin.component';
import { DataTableHeaderComponent } from 'app/layout/data-table/data-table-header/data-table-header.component';
import { DataTableComponent } from 'app/layout/data-table/data-table/data-table.component';
import { DataTableFilterTypesComponent } from 'app/layout/data-table/data-table-filter-types/data-table-filter-types.component';
import { SetpointQueryQuestionsComponent } from 'app/setpoints/setpoint-query/setpoint-query-questions/setpoint-query-questions.component';
import { SiteCollectionComponent } from 'app/sites/site-collections/site-collection/site-collection.component';
import { DialogAssetEditComponent } from 'app/dialogs/dialog-asset-edit/dialog-asset-edit.component';
import { EnergyAssetGraphComponent } from 'app/energy/components/energy-asset-graph/energy-asset-graph.component';
import { OccPercentageBarComponent } from 'app/layout/occ-percentage-bar/occ-percentage-bar.component';
import { DropdownComponent } from 'app/layout/dropdown/dropdown.component';
import { MonthSelectComponent } from 'app/layout/month-select/month-select.component';
import { RatingAeComponent } from 'app/layout/rating-ae/rating-ae.component';
import { DataNoteworthyTagsComponent } from 'app/layout/data-noteworthy-tags/data-noteworthy-tags.component';
import { D3ChartAnnotateComponent } from 'app/charts/d3-chart-annotate/d3-chart-annotate.component';
import { EnergyMetersComponent } from '../../energy/energy-meters/energy-meters.component';
import { IssueTrackingCreateComponent } from '../../issue-tracking/issue-tracking-create/issue-tracking-create.component';
import { IssueTrackingEntityPickerComponent } from '../../issue-tracking/issue-tracking-entity-picker/issue-tracking-entity-picker.component';
import { SetpointQueryIssuesComponent } from '../../setpoints/setpoint-query/setpoint-query-issues/setpoint-query-issues.component';
import { IssueTrackingCreateSiteComponent } from '../../issue-tracking/issue-tracking-create-site/issue-tracking-create-site.component';
import { EchartComponent } from "app/shared/components/echart/echart.component";
import { SoftwareAssuranceComponent } from '../../policies/software-assurance/software-assurance.component';
import { IssueTrackingListComponent } from '../../issue-tracking/issue-tracking-list/issue-tracking-list.component';
import { IssueTrackingItemComponent } from '../../issue-tracking/issue-tracking-item/issue-tracking-item.component';
import { IssueTrackingAuditComponent } from '../../issue-tracking/issue-tracking-audit/issue-tracking-audit.component';
import { IssueTrackingCommentsComponent } from '../../issue-tracking/issue-tracking-comments/issue-tracking-comments.component';
import { IssueTrackingUpdateComponent } from '../../issue-tracking/issue-tracking-update/issue-tracking-update.component';
import { IssueTrackingExportComponent } from '../../issue-tracking/issue-tracking-export/issue-tracking-export.component';
import { IssueTrackingStatsComponent } from '../../issue-tracking/issue-tracking-stats/issue-tracking-stats.component';
import { SitePlanFloorplanContainerComponent } from 'app/site-plan/site-plan-v2/site-plan-floorplan-container/site-plan-floorplan-container.component';
import { SitePlanAssetComponent } from '../../profiling/site-plan/site-plan-asset/site-plan-asset.component';
import { SitePlanDashboardComponent } from '../../profiling/site-plan/site-plan-dashboard/site-plan-dashboard.component';
import { SitePlanShapeComponent } from '../../profiling/site-plan/site-plan-shape/site-plan-shape.component';
import { SitePlanComponent } from '../../profiling/site-plan/site-plan.component';
import { SiteTableComponent } from '../../profiling/site-table/site-table.component';
import { SitePlanMenuComponent } from '../../profiling/site-plan/site-plan-menu/site-plan-menu.component';
import { SitePlanV2Component } from '../../site-plan/site-plan-v2/site-plan-v2.component';
import { SitePlanFloorplanComponent } from '../../site-plan/site-plan-v2/site-plan-floorplan/site-plan-floorplan.component';
import { SitePlanFloorplanToolbarComponent } from '../../site-plan/site-plan-v2/site-plan-floorplan/site-plan-floorplan-toolbar/site-plan-floorplan-toolbar.component';
import { SitePlanShapeControlComponent } from '../../profiling/site-plan/site-plan-shape/site-plan-shape-control/site-plan-shape-control.component';
import { ButtonSitePlanDashboardConfigComponent } from '../../profiling/site-plan/site-plan-dashboard/button-site-plan-dashboard-config/button-site-plan-dashboard-config.component';
import { AssetViewComponent } from '../../assets/asset-view/asset-view.component';
import { SitePlanDashboardContainerComponent } from "../../profiling/site-plan/site-plan-dashboard/site-plan-dashboard-container/site-plan-dashboard-container.component";
import { SensorPopupComponent } from '../../layout/sensor-popup/sensor-popup.component';
import { FieldViewComponent } from '../../chips/field-view/field-view.component';
import { ExplorerApiComponent } from '../../developer/explorer/explorer-api/explorer-api.component';
import { SiteChartComponent } from '../../profiling/site-chart/site-chart.component';
import { ShapeManageOccupancyComponent } from '../../profiling/site-plan/shape-manage/shape-manage-occupancy/shape-manage-occupancy.component';
import { ShapeManageComponent } from '../../profiling/site-plan/shape-manage/shape-manage.component';
import { ToastComponent } from '../components/toast/toast.component';
import { InsightsFloorsComponent } from '../../insights/insights-floors/insights-floors.component';
import { InsightsFloorsReportComponent } from '../../insights/insights-floors/insights-floors-report/insights-floors-report.component';
import { SpdWeeklyComponent } from '../../site-plan/site-plan-dashboard/spd-weekly/spd-weekly.component';
import { SpdOccMonthlyComponent } from '../../site-plan/site-plan-dashboard/spd-occ-monthly/spd-occ-monthly.component';
import { SelectDialogComponent } from '../../layout/select-dialog/select-dialog.component';
import { OrgExportComponent } from '../../org-dashboard/org-export/org-export.component';
import { InsightsReportGatewayComponent } from '../../insights/aq/insights-report-gateway/insights-report-gateway.component';
import { InsightsReportTypeComponent } from '../../insights/aq/insights-report-type/insights-report-type.component';
import { InsightsAsAdminComponent } from '../../insights/as/insights-as-admin/insights-as-admin.component';
import { InsightsAsLandingComponent } from '../../insights/as/insights-as-landing/insights-as-landing.component';
import { InsightsAsReportComponent } from '../../insights/as/insights-as-report/insights-as-report.component';
import { InsightsAsUserComponent } from '../../insights/as/insights-as-user/insights-as-user.component';
import { InsightsFfCompareComponent } from '../../insights/ff/insights-ff-compare/insights-ff-compare.component';
import { InsightsFfLandingComponent } from '../../insights/ff/insights-ff-landing/insights-ff-landing.component';
import { InsightsFfReportComponent } from '../../insights/ff/insights-ff-report/insights-ff-report.component';
import { InsightsAirqualityConfigComponent } from '../../insights/insights-airquality/insights-airquality-config/insights-airquality-config.component';
import { InsightsAirqualityReportComponent } from '../../insights/insights-airquality/insights-airquality-report/insights-airquality-report.component';
import { InsightsAirqualityComponent } from '../../insights/insights-airquality/insights-airquality.component';
import { InsightsLandingComponent } from '../../insights/insights-landing/insights-landing.component';
import { InsightsReviewIssueTrackingComponent } from '../../insights/reviews/insights-review-item/insights-review-issue-tracking/insights-review-issue-tracking.component';
import { SelectBuildingComponent } from '../../insights/layout/select-building/select-building.component';
import { SelectReviewAnnotationComponent } from '../../insights/layout/select-review-annotation/select-review-annotation.component';
import { InsightsFfLcrComponent } from '../../insights/ff-lcr/insights-ff-lcr/insights-ff-lcr.component';
import { InsightsFfLcrHourlyChartComponent } from '../../insights/ff-lcr/insights-ff-lcr-hourly-chart/insights-ff-lcr-hourly-chart.component';
import { InsightsFfLcrMonthlyChartComponent } from '../../insights/ff-lcr/insights-ff-lcr-monthly-chart/insights-ff-lcr-monthly-chart.component';
import { InsightsFfLcrRollingYearComponent } from '../../insights/ff-lcr/insights-ff-lcr-rolling-year/insights-ff-lcr-rolling-year.component';
import { AqCollectionsComponent } from '../../insights/aq-collections/aq-collections.component';
import { AqCollectionsReportComponent } from 'app/insights/aq-collections/aq-collections-report/aq-collections-report.component';
import { AqReportTypeComponent } from 'app/insights/aq-collections/aq-collections-report/aq-report-type/aq-report-type.component';
import { AqConfigureRagComponent } from 'app/insights/aq-collections/aq-configure-rag/aq-configure-rag.component';
import { SafeUrlPipe } from "app/shared/safe-url.pipe";
import { ReportCollectionListComponent } from '../../reports/report-configure/report-collection-list/report-collection-list.component';
import { ReportBlockRenderComponent } from '../../reports/report-block-render/report-block-render.component';
import { ReportConfigureComponent } from '../../reports/report-configure/report-configure.component';
import { ReportCountByDayComponent } from '../../reports/report-count-by-day/report-count-by-day.component';
import { ReportListComponent } from '../../reports/report-list/report-list.component';
import { ReportViewComponent } from '../../reports/report-view/report-view.component';
import { ReportWeatherTableComponent } from '../../reports/report-weather-table/report-weather-table.component';
import { ReportTelemetryByDayComponent } from '../../reports/report-telemetry-by-day/report-telemetry-by-day.component';
import { ReportTelemetryMinMaxComponent } from '../../reports/report-telemetry-min-max/report-telemetry-min-max.component';
import { ReportTextComponent } from '../../reports/report-text/report-text.component';
import { ReportAirqualityComponent } from '../../reports/report-airquality/report-airquality.component';
import { ReportGatewayListComponent } from '../../reports/report-configure/report-gateway-list/report-gateway-list.component';
import { ReportMonthlyComponent } from '../../reports/report-monthly/report-monthly.component';
import { ReportTriggerComponent } from '../../reports/report-trigger/report-trigger.component';
import { ReportCustomComponent } from '../../reports/report-custom/report-custom.component';
import { ReportsPolicyComponent } from '../../reports/reports-policy/reports-policy.component';

import { TickButtonComponent } from 'app/chips/tick-button/tick-button.component';
import { TickComponent } from 'app/chips/tick/tick.component';
import { PchartComponent } from '../components/pchart/pchart.component';
@NgModule({
	declarations: [
		ReportTelemetryByDayComponent,
		ReportTelemetryMinMaxComponent,
		ReportTextComponent,
		ReportAirqualityComponent,
		ReportGatewayListComponent,
		ReportMonthlyComponent,
		ReportTriggerComponent,
		ReportCustomComponent,
		ReportsPolicyComponent,
		ReportBlockRenderComponent,
		ReportConfigureComponent,
		ReportCountByDayComponent,
		ReportListComponent,
		ReportViewComponent,
		ReportWeatherTableComponent,
		SiteChartComponent,
		ShapeManageOccupancyComponent,
		ShapeManageComponent,
		ExplorerApiComponent,
		FieldViewComponent,
		SensorPopupComponent,
		SitePlanDashboardContainerComponent,
		AssetViewComponent,
		ButtonSitePlanDashboardConfigComponent,
		SitePlanShapeControlComponent,
		SitePlanMenuComponent,
		SitePlanComponent,
		SitePlanDashboardComponent,
		SitePlanAssetComponent,
		SitePlanShapeComponent,
		SitePlanFloorplanContainerComponent,
		SiteTableComponent,
		SitePlanV2Component,
		SitePlanFloorplanComponent,
		SitePlanFloorplanToolbarComponent,
		EchartComponent,
		PageTitleComponent,
		SchematicsCardComponent,
		SchematicsStudioComponent,
		SchematicsDetailContainerComponent,
		InfoPanelComponent,
		PowerHourComponent,
		PleaseWaitComponent,
		ButtonComponent,
		SelectComponent,
		ToolbarComponent,
		DialogComponent,
		PanelComponent,
		SearchInputComponent,
		AmDateFormatPipe,
		AmTimeAgoPipe,
		AmCalendarPipe,
		WeatherTempComponent,
		ChipComponent,
		ButtonNotificationsComponent,
		ButtonAssetsComponent,
		DialogSelectComponent,
		ExplorerAssetComponent,
		ExplorerComponent,
		ExplorerSiteComponent,
		ExplorerChartComponent,
		SetpointQueryComponent,
		SetpointQueryHeaderComponent,
		SetpointQueryOccComponent,
		SetpointQueryOccFloorsComponent,
		SetpointQueryOccPlanComponent,
		SetpointQueryOccSquaresComponent,
		SetpointQueryOccConfigComponent,
		SetpointQueryOccTenservComponent,
		SetpointQueryTableComponent,
		SetpointQueryQuestionsComponent,
		SetpointListComponent,
		SetpointsExplorerComponent,
		SetpointDatesButtonComponent,
		SetpointQueryControlComponent,
		CalendarComponent,
		AssetViewerComponent,
		SqPowerComponent,
		D3BarComponent,
		D3ChartComponent,
		D3OccupancyComponent,
		D3SiteRagChartComponent,
		ThemePageSectionComponent,
		ThemePageContainerComponent,
		ButtonDatesComponent,
		ButtonSensorsComponent,
		ButtonTriggerComponent,
		DataFormComponent,
		MapComponent,
		AssetIconComponent,
		AssetMonitorComponent,
		TooltipDirective,
		AssetDashboardComponent,
		EnergyAssetGraphComponent,
		ButtonAssetAdminComponent,
		OccPercentageBarComponent,
		DropdownComponent,
		MonthSelectComponent,
		RatingAeComponent,
		DataTableHeaderComponent,
		DataTableComponent,
		DataTableFilterTypesComponent,
		DataNoteworthyTagsComponent,
		SiteCollectionComponent,
		D3ChartAnnotateComponent,
		EnergyMetersComponent,
		IssueTrackingCreateComponent,
		IssueTrackingEntityPickerComponent,
		SetpointQueryIssuesComponent,
		IssueTrackingCreateSiteComponent,
		SoftwareAssuranceComponent,
		IssueTrackingListComponent,
		IssueTrackingItemComponent,
		IssueTrackingAuditComponent,
		IssueTrackingCommentsComponent,
		IssueTrackingUpdateComponent,
		IssueTrackingExportComponent,
		IssueTrackingStatsComponent,
		ToastComponent,
		InsightsFloorsComponent,
		InsightsFloorsReportComponent,
		SpdWeeklyComponent,
		SpdOccMonthlyComponent,
		SelectDialogComponent,
		DialogAssetEditComponent,
		OrgExportComponent,
		InsightsReportGatewayComponent,
		InsightsReportTypeComponent,
		InsightsAirqualityComponent,
		InsightsAirqualityReportComponent,
		InsightsLandingComponent,
		InsightsReviewIssueTrackingComponent,
		InsightsAsAdminComponent,
		InsightsAsLandingComponent,
		InsightsAsReportComponent,
		InsightsAsUserComponent,
		InsightsFfCompareComponent,
		InsightsFfLandingComponent,
		InsightsFfReportComponent,
		InsightsAirqualityConfigComponent,
		SelectBuildingComponent,
		SelectReviewAnnotationComponent,
		InsightsFfLcrComponent,
		InsightsFfLcrHourlyChartComponent,
		InsightsFfLcrMonthlyChartComponent,
		InsightsFfLcrRollingYearComponent,
		AqCollectionsComponent,
		AqCollectionsReportComponent,
		AqReportTypeComponent,
		AqConfigureRagComponent,
		SafeUrlPipe,
		ReportCollectionListComponent,
		TickButtonComponent,
		TickComponent,
		PchartComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		RouterModule
	],
	exports: [
		SiteChartComponent,
		ShapeManageOccupancyComponent,
		ShapeManageComponent,
		ExplorerApiComponent,
		FieldViewComponent,
		SensorPopupComponent,
		SitePlanDashboardContainerComponent,
		AssetViewComponent,
		ButtonSitePlanDashboardConfigComponent,
		SitePlanShapeControlComponent,
		SitePlanMenuComponent,
		SitePlanComponent,
		SitePlanDashboardComponent,
		SitePlanAssetComponent,
		SitePlanShapeComponent,
		SitePlanFloorplanContainerComponent,
		SiteTableComponent,
		SitePlanV2Component,
		SitePlanFloorplanComponent,
		SitePlanFloorplanToolbarComponent,
		EchartComponent,
		PageTitleComponent,
		SchematicsCardComponent,
		SchematicsStudioComponent,
		InfoPanelComponent,
		PowerHourComponent,
		PleaseWaitComponent,
		ButtonComponent,
		SelectComponent,
		ToolbarComponent,
		DialogComponent,
		PanelComponent,
		SearchInputComponent,
		AmDateFormatPipe,
		AmTimeAgoPipe,
		AmCalendarPipe,
		WeatherTempComponent,
		ChipComponent,
		ButtonNotificationsComponent,
		ButtonAssetsComponent,
		DialogSelectComponent,
		ExplorerAssetComponent,
		ExplorerComponent,
		ExplorerSiteComponent,
		ExplorerChartComponent,
		SetpointQueryComponent,
		SetpointQueryHeaderComponent,
		SetpointQueryTableComponent,
		SetpointQueryOccComponent,
		SetpointQueryOccFloorsComponent,
		SetpointQueryOccPlanComponent,
		SetpointQueryOccSquaresComponent,
		SetpointQueryOccConfigComponent,
		SetpointQueryOccTenservComponent,
		SetpointListComponent,
		SetpointDatesButtonComponent,
		SetpointQueryControlComponent,
		SetpointQueryQuestionsComponent,
		CalendarComponent,
		AssetViewerComponent,
		SqPowerComponent,
		D3BarComponent,
		D3ChartComponent,
		D3OccupancyComponent,
		D3SiteRagChartComponent,
		ThemePageSectionComponent,
		ThemePageContainerComponent,
		ButtonDatesComponent,
		ButtonSensorsComponent,
		ButtonTriggerComponent,
		DataFormComponent,
		MapComponent,
		AssetIconComponent,
		AssetMonitorComponent,
		TooltipDirective,
		AssetDashboardComponent,
		EnergyAssetGraphComponent,
		ButtonAssetAdminComponent,
		OccPercentageBarComponent,
		DropdownComponent,
		MonthSelectComponent,
		RatingAeComponent,
		DataTableHeaderComponent,
		DataTableComponent,
		DataTableFilterTypesComponent,
		DataNoteworthyTagsComponent,
		SiteCollectionComponent,
		D3ChartAnnotateComponent,
		EnergyMetersComponent,
		IssueTrackingEntityPickerComponent,
		IssueTrackingCreateSiteComponent,
		IssueTrackingListComponent,
		IssueTrackingItemComponent,
		IssueTrackingAuditComponent,
		IssueTrackingCommentsComponent,
		ToastComponent,
		SpdWeeklyComponent,
		SpdOccMonthlyComponent,
		SelectDialogComponent,
		DialogAssetEditComponent,
		OrgExportComponent,
		InsightsReportGatewayComponent,
		InsightsReportTypeComponent,
		InsightsAirqualityComponent,
		InsightsAirqualityReportComponent,
		InsightsLandingComponent,
		InsightsReviewIssueTrackingComponent,
		InsightsAsAdminComponent,
		InsightsAsLandingComponent,
		InsightsAsReportComponent,
		InsightsAsUserComponent,
		InsightsFfCompareComponent,
		InsightsFfLandingComponent,
		InsightsFfReportComponent,
		InsightsAirqualityConfigComponent,
		SelectBuildingComponent,
		SelectReviewAnnotationComponent,
		AqCollectionsComponent,
		AqCollectionsReportComponent,
		AqReportTypeComponent,
		AqConfigureRagComponent,
		SafeUrlPipe,
		ReportCollectionListComponent,
		TickButtonComponent,
		TickComponent,
		ReportConfigureComponent,
		ReportCountByDayComponent,
		ReportListComponent,
		ReportViewComponent,
		ReportWeatherTableComponent,
		ReportTelemetryByDayComponent,
		ReportTelemetryMinMaxComponent,
		ReportTextComponent,
		ReportAirqualityComponent,
		ReportGatewayListComponent,
		ReportMonthlyComponent,
		ReportTriggerComponent,
		ReportCustomComponent,
		ReportsPolicyComponent,
		PchartComponent

	],
	providers: []
})
export class SharedModule { }
